import { useQuery } from 'react-query';

import { IQueryParameters } from 'common/models';
import { QUERY_KEYS } from 'consts/queryKeys';
import { getPropertiesLite } from 'modules/_common/api';

interface IProps extends IQueryParameters {
  enabled: boolean | undefined;
}

export const useQueryPropertiesLite = ({ params, enabled }: IProps) => {
  return useQuery([QUERY_KEYS.LITE_PROPERTIES, params], () => getPropertiesLite({ params }), {
    enabled,
  });
};
